import { useState } from "react";
import ProductTabs from "./ProductTabs";
import produktMargenImg from "../../../assets/produktmargen.png";
import cockpit from "../../../assets/cockpit.png";
import "./Products.scss";

interface ProduktContent {
  description: string;
  features: string[];
  image: string;
  imageAlt: string;
}

/**
 * Produkte-Seite der Landingpage.
 *
 * Hinweis: Die einzelnen Module (Margenkalkulator, CRM, Cockpit) werden
 * absichtlich nicht mehr direkt von hier verlinkt. Sie sind ausschließlich
 * nach erfolgtem Login über die AppShell erreichbar. Der "Modul öffnen"-Button
 * und die Bild-Links wurden daher entfernt.
 */
const tabs = ["Margenkalkulator", "CRM", "Cockpit"];

const produktContents: Record<string, ProduktContent> = {
  Margenkalkulator: {
    description:
      "Die Software für Margenkalkulation bietet alle Tools, die Sie benötigen, um Ihre Angebote präzise zu berechnen und Ihre Gewinnmargen zu optimieren.",
    features: [
      "Echtzeit-Kalkulation",
      "Szenarien-Vergleich",
      "Rabatt-Simulation",
      "Kostenstellen-Analyse",
    ],
    image: produktMargenImg,
    imageAlt: "Margenkalkulator Vorschau",
  },
  CRM: {
    description:
      "Unser CRM-System hilft Ihnen dabei, Ihre Kundendaten zentral zu verwalten und die Kommunikation mit Ihren Leads und Kunden zur richtigen Zeit am richtigen Ort zu führen.",
    features: [
      "Kontakt-Management",
      "Vertriebs-Pipeline",
      "E-Mail-Marketing",
      "KI-Automatisierung",
    ],
    image: cockpit,
    imageAlt: "CRM Vorschau",
  },
  Cockpit: {
    description:
      "Das Cockpit ist Ihre zentrale Steuerungs-Einheit für alle Unternehmenskennzahlen. Behalten Sie den Überblick über Ihre Performance in Echtzeit.",
    features: [
      "Echtzeit-Dashboards",
      "ESG & CO2 Reporting",
      "Asset-Management",
      "Portfolio-Übersicht",
    ],
    image: cockpit,
    imageAlt: "Cockpit Vorschau",
  },
};

const Products = () => {
  const [activeTab, setActiveTab] = useState<string>(tabs[0]);
  const content = produktContents[activeTab];

  return (
    <div className="produkte-page">
      <div className="produkte-page__header">
        <h1>Unsere Produkte</h1>
      </div>

      <ProductTabs
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        tabs={tabs}
      />

      <div className="produkte-page__content">
        <div className="produkte-page__tab-content">
          <div className="produkte-page__text-section">
            <p>{content.description}</p>
            <h3>Beliebte Funktionen:</h3>
            <ul className="produkte-page__features">
              {content.features.map((feature) => (
                <li key={feature}>{feature}</li>
              ))}
            </ul>
          </div>
          <div className="produkte-page__image-section">
            <img src={content.image} alt={content.imageAlt} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
